import * as React from "react";
import { Table } from "../table/table/table.mjs";
import { useSlidesToShowAmount, usePlaceholderArray } from "./utils.mjs";
const ProductComparisonTable = (props) => {
  const { itemCount, isMobile, children, ...rest } = props;
  const visibleItemCount = useSlidesToShowAmount();
  const placeholders = usePlaceholderArray(itemCount);
  const totalItemCount = itemCount + placeholders.length;
  return /* @__PURE__ */ React.createElement(Table, { className: "product-comparison__table", minWidth: isMobile ? "".concat(totalItemCount / visibleItemCount * 100, "%") : void 0, ...rest }, children);
};
export {
  ProductComparisonTable
};
